import {goToNextImage} from './_goToNextImage';


export var hoverImage = function($img, passedSpeed) {
	var hoverSpeed = passedSpeed || window.initialSpeed || 500;
    if ($('html.no-touchevents').length > 0) {
        $img.data("runningAlt", "true");
        setTimeout(function() {
            if ($img.data("hovered") == 'true') {
                hoverSpeed = window.hoverSpeed || 1000;
                goToNextImage($img);
                hoverImage($img, hoverSpeed);
            } else {
                $img.data("runningAlt", "false");
            }
        }, hoverSpeed);
    }
    if ($('html.touch').length > 0) {
        $img.data("runningAlt", "false");
    }

};
